<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<mat-card>
  <mat-card-title>Change Password</mat-card-title>

  <!-- <h4>Update Password</h4> -->
  <form novalidate [formGroup]="passForm" #formDirective="ngForm"  (submit)="updatePassword(formDirective)" >

    <!-- <wl-input type="text" label="Enter Old Password" placeholder="Enter Old Password" formControlName="oldpassword" disabled=false></wl-input> -->
    <wl-input type="password" label="Enter Current Password" placeholder="{{currentPasswordString}}" formControlName="oldPrd" disabled=false></wl-input>
    <wl-input type="password" label="Enter New Password" placeholder="Enter New Password" formControlName="newpassword" disabled=false></wl-input>
    <div class="error" *ngIf="passForm.get('newpassword').touched && passForm.get('newpassword').hasError('required')">Password is required</div>
    <div class="error" *ngIf="passForm.get('newpassword').touched && passForm.get('newpassword').hasError('pattern')"> 
      Password must be 8-24 characters and include at least one uppercase, lowercase, number, and special character. Spaces are not allowed.
    </div>
    <wl-input type="password" label="Confirm New Password" placeholder="Confirm New Password" formControlName="confpassword" disabled=false></wl-input>
    <wl-button [disabled]="!passForm.valid">Update</wl-button>

  </form>
</mat-card>
